import React, { useRef, useEffect } from 'react';
import { motion } from 'framer-motion';

import LogoutIcon from '@mui/icons-material/Logout';
import HelpOutline from '@mui/icons-material/HelpOutline';

import { Link } from 'react-router-dom';
import { useStateContext } from '../contexts/ContextProvider';

const ProfileDropdown = ({ onClose, profileRef, dropdownRef }) => {
  const { setIsLogged } = useStateContext();

  const handleClickOutside = (event) => {
    // Delay checking for outside click slightly to prevent instant re-toggle issue
    setTimeout(() => {
      if (profileRef.current && profileRef.current.contains(event.target)) return;
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        onClose();
      }
    }, 100); // Small delay ensures proper toggle behavior
  };

  const handleLogout = () => {
    localStorage.removeItem('jwt');
    setIsLogged(false);
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <motion.div
      className="absolute top-[4.9em] right-3 bg-main-bg p-1 max-w-sm 
             border-gray-500 border-t  "
      ref={dropdownRef}
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.95 }}
      transition={{ duration: 0.1 }}
    >
      <Link to="/About" className="no-underline flex px-6 py-2.5 font-semibold text-gray-400 space-x-3 items-center border-b border-gray-500 last:border-0 hover:bg-light-gray select-none">
        <HelpOutline />
        <span>About</span>
      </Link>
      <a href="#" className="no-underline flex px-6 py-2.5 font-semibold text-gray-400 space-x-3 items-center hover:bg-light-gray select-none" onClick={handleLogout}>
        <LogoutIcon />
        <span>Logout</span>
      </a>
      <hr className="w-full border-t border-gray-500" />

    </motion.div>
  );
};

export default ProfileDropdown;
